import { FC, useState } from 'react';

// Components
import { TooltipV2 } from '@velinsi/smp-widgets-ui';
import Image from '../../../../../../packages/HOC/AccessibilityImage';

// Utils
import { defaultHandleTournamentClick } from '@sportal365/smp-widget-utils';

// Types
import { ITournament } from '../../../types';
import { ISubscriberInfo } from '../../../../../../packages/types';
import { TOURNAMENT_ENTITY } from '../../../../../../packages/constants/entityTypes';

interface Props extends ITournament {
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
}

const TournamentIcon: FC<Props> = ({ id, url, name, image, handleClick }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => setShow(true);
  const handleMouseLeave = () => setShow(false);

  const handleTournamentClick = () => {
    defaultHandleTournamentClick(handleClick, id, name);
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleTournamentClick}
      className='tournament flex relative'
    >
      <a href={url} target='_blank' rel='noreferrer' className='w-6 h-6 bg-white rounded-2'>
        <Image src={image} alt={name} entityType={TOURNAMENT_ENTITY} className='tournament-icon w-6 h-6' />
      </a>
      {show && (
        <TooltipV2 showTooltip={show}>
          <span className='text-standingsTooltipContainerTextColor'>{name}</span>
        </TooltipV2>
      )}
    </div>
  );
};

export default TournamentIcon;
